import React, { useState, useEffect, useRef} from 'react';
import { useHistory } from "react-router-dom";
import axios from 'axios';
import socketIOClient from "socket.io-client";
import Box from './Box';
import './css/Login.css';
import { ReactComponent as LogoBig } from './img/urania.svg';
import Tools from './Tools';
import { isChrome } from 'react-device-detect';
import { useSoftphone } from './SoftphoneContext.jsx';

const Login = (props) => {
    const [error, setError] = useState(null);
    const [errorDesc, setErrorDesc] = useState(null);
    const [data, setData] = useState({account: '',password: '',});
    //const [softphone, setSoftphone] = useState({}); 
    const [loading, setLoading] = useState(false);
    const [apiVersion, setApiVersion] = useState(null);

    const { register } = useSoftphone();

    useEffect(() => {
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/`, {
            params: {}
        })
        .then(function (response) {
            setApiVersion(response.data.version);
        })
    }, []);

    const handleInputChange = (event) => {
        setData({ ...data, [event.target.name]: event.target.value })
    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            loginUser();
        }
    }

    const InfoLogin = () => {
        if (error){
            return <p className='error'>Error: {errorDesc}. ({error})</p>;
        }else{
            return null;
        }
    }

    const loginUser = () => {
        setLoading(true);
        axios.get(`${process.env.REACT_APP_URI_API_CRM}/user`, {
            params: { account: data.account, pwd: data.password }
        })
        .then(function (response) {
            //setLoading(false);
            if(response.data.status===401){
                setErrorDesc('Las credenciales de acceso no son válidas; verifíque e intente nuevamente');
                setError('Unauthorized');
                setLoading(false);
            } else{
                let currentUser = response.data.user;


                //SE ELIMINA DE LA SESIÓN INICIAL PARA QUE NO 
                //PRE SELECCIONE AL INICIO, SOLO CUANDO RECARGA LA PAGINA DE CAMPAÑAS
                //currentUser.lastCampaignId=null;
                

                sessionStorage.setItem('sessionData', JSON.stringify(currentUser));
                if (currentUser.profile_code !== 'EXEC_CHAT') {
                    register(String(currentUser.extension), process.env.REACT_APP_ASTERISK_PASSWORD);
                } 

                // //connect to socket on login (also connect in SocketActions if user refresh)
                // const socket=Tools.connectClientToSocket(socketIOClient, currentUser.extension);
                
                // //backup socket on memory
                // Tools.currentSocketConnection=socket;

                
                Tools.logUserStatus({code:'LOGIN', desc:'LOGIN'}).then(function (result) {
                    Tools.logUserStatus({ code: 'LOGGED', desc: 'En sistema' }).then(function (result) {
                        setLoading(false);
                        if(currentUser.profile_code==='SUPV'){
                            history.push('/reports');
                        } else if (currentUser.profile_code === 'CONS_CHAT') {  
                            history.push('/chatDashboard');
                        }else{
                            history.push('/campaigns');
                        }
                    });
                });
                
                
            }
        })
        .catch(function (error) {
            console.log("Error:", error.message);
            setErrorDesc('Se produjo un error tratando de acceder al servicio de login, favor comuníquese con Athena');
            setError(error.message);
            setLoading(false);
        });
    }

    let history = useHistory();

    return (

        <div className="loginWrapper">
            <div className="loginSidebar hiddenXS">
                {!isChrome?(<div className='loginAdvice'>Atención: Para una mejor experiencia de usuario, se recomienda el uso de <b>Google Chrome</b> para acceder a Urania CRM.</div>):null}
            </div>   
            <div className="content">
                
                <div className="right">
                    <LogoBig className="logo"/>
                    <p className='appVersion'>[Client version: {process.env.REACT_APP_VERSION_CODE}<br/>API version: {apiVersion}]</p>
                </div>

                <form>
                    <div className="flexRow mgb">
                        <div className="flexCol full">
                            <Box type="text" className="full" name="account" label="Nombre" placeholder="Ingrese cuenta de usuario" autoCapitalize="off" onChange={handleInputChange}></Box>
                        </div>
                    </div>
                    <div className="flexRow mgb">
                        <div className="flexCol full">
                            <Box type="password" className="full" name="password" label="contraseña" placeholder="Ingrese contraseña" onChange={handleInputChange} onKeyDown={handleKeyDown}></Box>
                        </div>
                    </div>
                    
                    <div className="right">
                        <button className={loading ? 'default loading' : 'default'} type="button" onClick={loginUser}>Login</button>
                    </div>

                    <InfoLogin/>
                </form>
            </div>
        </div>
    );
}

export default Login;